import { PolicyDocumentType } from '@clearcover/core-app-types';
import { AxiosError } from 'axios';
import { createContext, useContext } from 'react';

export type DownloadDocumentType = {
  downloadIdCard: () => Promise<void>;
  downloadPolicyDocument: (document: PolicyDocumentType) => () => Promise<void>;
};

export type DocumentsContextType = {
  loading: boolean;
  error?: AxiosError<any>;
  idCard?: PolicyDocumentType;
  documents: Array<PolicyDocumentType>;
  downloadDocument: DownloadDocumentType;
  downloadingDocuments: Record<string, null>;
  refetch: () => void;
};

export const DocumentsContext = createContext<DocumentsContextType>({
  idCard: {
    id: 'id-card-uuid',
    cancelledAt: null,
    completedAt: null,
    name: 'id-card-name',
    type: 'id_card',
    createdAt: 'id-card-createdAt',
    signedAssetId: 'id-card-signedAssetId',
    viewedAt: 'id-card-viewedAt',
  },
  documents: [],
  loading: false,
  downloadDocument: {
    downloadIdCard: () => Promise.resolve(),
    downloadPolicyDocument: () => () => Promise.resolve(),
  },
  downloadingDocuments: {},
  refetch: () => {},
});

export const useDocumentsContext = () => {
  return useContext(DocumentsContext);
};

export const createMockDocumentContext = (
  documents: Array<PolicyDocumentType>
) => ({
  documents,
  loading: false,
  downloadDocument: {
    downloadIdCard: () => Promise.resolve(),
    downloadPolicyDocument: () => () => Promise.resolve(),
  },
  downloadingDocuments: {},
  refetch: () => {},
});
